import { useState } from 'react';
import { Link } from 'react-router-dom';
import { featuredArticles, dailyContest } from '@/mocks/home';

export default function FeaturedGridSection() {
  const [hoveredId, setHoveredId] = useState<number | null>(null);

  return (
    <section className="bg-background-50 py-14 md:py-20" aria-label="精选大瓜与每日大赛">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            精选大瓜 <span className="text-3xl md:text-5xl">🍉</span>
          </h2>
          <p className="mt-2 text-foreground-500 text-sm">
            深度爆料，有据可查
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {featuredArticles.map((article, index) => {
            const isHovered = hoveredId === article.id;
            const isDefaultExpanded = hoveredId === null && index === 0;

            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className={`relative rounded-lg overflow-hidden cursor-pointer group transition-all duration-500 ease-out ${
                  isHovered || isDefaultExpanded ? 'md:col-span-2' : 'md:col-span-1'
                }`}
                onMouseEnter={() => setHoveredId(article.id)}
                onMouseLeave={() => setHoveredId(null)}
                style={{ minHeight: '320px' }}
              >
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="absolute inset-0 w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-black/10"></div>

                <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
                  <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-500/90 text-background-950 text-xs font-semibold mb-3">
                    {article.category}
                  </span>
                  <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 leading-snug mb-2">
                    {article.title}
                  </h3>
                  <p
                    className={`text-background-50/70 text-sm leading-relaxed transition-all duration-500 ${
                      (isHovered || isDefaultExpanded)
                        ? 'opacity-100 max-h-20'
                        : 'opacity-0 max-h-0 overflow-hidden'
                    }`}
                  >
                    {article.excerpt}
                  </p>
                  <span className="block mt-2 text-background-50/50 text-xs">
                    {article.time}
                  </span>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="mt-16">
          <div className="flex items-center gap-3 mb-8">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-fire-line"></i>
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              每日大赛
            </h2>
            <span className="text-xs text-foreground-400">今日投票进行中</span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            {dailyContest.map((item, index) => (
              <Link
                key={item.id}
                to={`/article/${item.slug}`}
                className="bg-background-100 rounded-lg overflow-hidden group cursor-pointer hover:-translate-y-1 transition-all duration-300"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-0.5 rounded-full bg-background-950/70 text-accent-400 text-xs font-bold">
                      #{index + 1}
                    </span>
                  </div>
                </div>
                <div className="p-4">
                  <h3 className="text-foreground-900 font-semibold text-sm leading-snug line-clamp-2 mb-3">
                    {item.title}
                  </h3>
                  <div className="flex items-center justify-between">
                    <button className="whitespace-nowrap px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold hover:bg-primary-200 transition-colors cursor-pointer">
                      投票支持
                    </button>
                    <span className="text-xs text-foreground-500 flex items-center gap-1">
                      <i className="ri-thumb-up-line text-accent-500"></i>
                      {item.votes}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}